import tenantReducer from './features/tenant/tenantSlice'
import roleReducer from './features/role/roleSlice'
import userReducer from './features/user/userSlice'
import universityReducer from './features/university/universitySlice'
import {combineReducers} from 'redux'
import facultyReducer from './features/faculty/facultySlice'
import departmentReducer from './features/department/departmentSlice'
import subDepartmentReducer from './features/sub-department/subDepartmentSlice'
import programReducer from './features/program/programSlice'
import countryReducer from './features/country/countrySlice'
import provinceReducer from './features/province/provinceSlice'
import districtReducer from './features/district/districtSlice'
import addressReducer from './features/address/addressSlice'
import graduationCardReducer from './features/graduation-card/graduationCardSlice'
import graduatedCardReducer from './features/graduation-card/graduatedCardSlice'
import graduatedDocumentReducer from './features/graduation-document/graduatedDocumentSlice'
import graduatedReducer from './features/graduated/graduatedSlice'
import graduatedWorkInfoReducer from './features/graduation-work-info/graduatedWorkInfoSlice'
import programTypeReducer from './features/program-type/programTypeSlice'
import codeGroupReducer from './features/code-group/codeGroupSlice'
import codeReducer from './features/code/codeSlice'
import profileReducer from './features/profile/profileSlice'
import sendEmailReducer from './features/send-email/sendEmailSlice'
import emailTemplateReducer from './features/email-template/emailTemplateSlice'
import newsReducer from './features/news/newsSlice'
import newsAttachmentReducer from './features/news-attachment/newsAttachmentSlice'
import emailHistoryReducer from './features/email-history/emailHistorySlice'
import jobReducer from './features/job/jobSlice'
import companyReducer from './features/company/companySlice'
import kvkkReducer from './features/kvkk/kvkkSlice'
import attachmentReducer from './features/attachment/attachmentSlice'
import graduatedJobApplicationReducer from './features/graduated-job-application/graduatedJobApplicationSlice'
import accountReducer from './features/account/accountSlice'
import dashboardReducer from './features/dashboard/dashboardSlice'
import cardRequestReducer from './features/card-request/cardRequestSlice'
import workExperienceReducer from './features/work-experience/workExperienceSlice'
export const rootReducer = combineReducers({
  tenant: tenantReducer,
  role: roleReducer,
  user: userReducer,
  university: universityReducer,
  faculty: facultyReducer,
  department: departmentReducer,
  subDepartment: subDepartmentReducer,
  program: programReducer,
  country: countryReducer,
  province: provinceReducer,
  district: districtReducer,
  address: addressReducer,
  graduationCard: graduationCardReducer,
  graduatedCard: graduatedCardReducer,
  graduated: graduatedReducer,
  graduatedDocument: graduatedDocumentReducer,
  graduatedWorkInfo: graduatedWorkInfoReducer,
  programType: programTypeReducer,
  codeGroup: codeGroupReducer,
  code: codeReducer,
  profile: profileReducer,
  sendEmail: sendEmailReducer,
  emailTemplate: emailTemplateReducer,
  news: newsReducer,
  newsAttachment: newsAttachmentReducer,
  emailHistory: emailHistoryReducer,
  job: jobReducer,
  company: companyReducer,
  kvkk: kvkkReducer,
  attachment: attachmentReducer,
  graduatedJobApplication: graduatedJobApplicationReducer,
  account: accountReducer,
  dashboard: dashboardReducer,
  cardRequest: cardRequestReducer,
  workExperience: workExperienceReducer
})
